import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode === 'circular')?_c(VProgressCircular,{attrs:{"value":_vm.value,"color":_vm.color,"size":_vm.size,"width":_vm.width,"data-qa":_vm.dataQa,"indeterminate":""}}):(_vm.mode === 'linear')?_c(VProgressLinear,{attrs:{"active":"","color":_vm.color,"data-qa":_vm.dataQa,"indeterminate":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }